<template>
  <div class="bundle-card">
    <div class="slider-wrapper">
      <div class="d-flex align-center">
        <div :style="options.length === 1 && {   pointerEvents: 'none' }">
          <vue-simple-select v-if="width <= 850" v-model="selected" :options="options"/>
        </div>
        <div :class="[lang === 'ar' ? 'bold-ar' : 'bold-en', 'titles ']">{{ $t('profile.charTitles') }}</div>
      </div>
      <div v-if="width > 850" class="characters">
        <div v-for="(item, i) in data" :key="i" :class="[lang === 'ar' ? 'border-ar' : 'border-en', 'character-container mt-3']">
          <Chart :data="{percent: item.percent, id: `char-${index}-${i}`, type: item.type, consume: item.consume}" />
          <div class="consume pt-3 regular-ar">{{ item.consume }} / {{ item.total }}</div>
        </div>
      </div>
    </div>
    <div v-for="(item, i) in data" :key="i">
      <div v-if="item.type === selected.value && width <= 850"  :class="[lang === 'ar' ? 'border-ar' : 'border-en', 'character-container']">
        <Chart :data="{percent: item.percent, id: `char-${index}-${i}`, type: item.type, total: item.total,consume: item.consume}" />
        <div class="consume pt-3 regular-ar text-center">{{ item.consume }} / {{ item.total }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import Chart from '../chart/Chart'
import VueSimpleSelect from 'vue-simple-custom-select'
export default {
  components: { Chart, VueSimpleSelect },
  props: {
    data: Array,
    index: Number
  },
  data () {
    return {
      checked: true,
      lang: this.$lang,
      width: this.$store.state.window,
      selected: null,
      options: []
    }
  },
  watch: {
  },
  created () {
    if (this.data) {
      for (let i = 0; i < this.data.length; i++) {
        this.options.push({ label: this.data[i].type, value: this.data[i].type })
      }
      this.selected = this.options[0]
    }
    this.$watch(() => {
      return this.$store.state.window
    }, val => {
      this.width = this.$store.state.window
    })
  }
}
</script>
<style lang="scss" scoped>
@import "src/assets/sass/main";
/*----------------------------------------------------- style -------------------------------------------------*/
.titles {
  width: 100%
}
.titles > div {
  font-size: 18px
}
.slider-wrapper {
  text-align: center;
}
.slider-wrapper > .titles {
  font-size: 20px;
  color: #1d1d1d !important;
}
.characters{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.character-container{
  flex-grow: 1;
  height: max-content;
}
.border-en {
  border-right: 2px solid rgba(106,106,106,0.15);
}
.border-ar {
  border-left: 2px solid rgba(106,106,106,0.15);
}
.character-container:last-child{
  border: none;
}
.consume {
  font-size: 16.5px
}
/*-------------------------------------------------------------------------------------------------------------*/
</style>
<style lang="scss">
.bundle-card {
  button#vue-simple-select-option-68aa-070b-2cb0-f9ff {
    background: none !important;
    color: #6A6A6A !important;
  }
}
</style>
